import { useEffect, useState } from 'react';
import type { ClinicStartMode } from '../api';

const CARRIED_MODE = 'clinicMode';

const urlMode = (): ClinicStartMode | null => {
  const params = new URLSearchParams(window.location.search);
  if (params.has('new')) return 'restart';
  if (params.has('redo')) return 'redo';
  return null;
};

/**
 * `?new` shows the signed-out page; signing in on it restarts the member's application as a brand-new member.
 * `?redo` reopens a submitted application for changes. Session storage carries either through the sign-in.
 */
export function useClinicTesting(): {
  publicView: boolean;
  mode: ClinicStartMode;
} {
  const [testing] = useState(() => ({
    publicView: urlMode() === 'restart',
    mode:
      urlMode() ??
      (sessionStorage.getItem(CARRIED_MODE) as ClinicStartMode | null) ??
      'start',
  }));
  useEffect(() => {
    if (testing.publicView) return;
    sessionStorage.removeItem(CARRIED_MODE);
    // A reload after resubmitting must not reopen the application again.
    if (urlMode() === 'redo')
      window.history.replaceState(null, '', window.location.pathname);
  }, [testing]);
  return testing;
}

/** Keeps a `?new` or `?redo` visit's mode for the application that opens after sign-in. */
export function carryRestart() {
  const mode = urlMode();
  if (mode) sessionStorage.setItem(CARRIED_MODE, mode);
}
